import axios from "axios";

const client = axios.create({
    baseURL: "https://wp267063.wpdns.ca/wp-json/wp/v2",
    timeout: 5000,
    headers: {
        'Content-Type': 'application/json',
    }, 
});

// Interceptor for error handling or token injection
client.interceptors.response.use(
    (response) => response,
    (error) => {
      console.error('API Error:', error.response?.data || error.message);
      return Promise.reject(error);
    }
  );
  
  export default client;